export enum Experiment {
  EnableOOIInEditor = 'specs.membersArea.framelessEditorPW',
  TitleForAll = 'specs.profileCardOOI.TitleForAll',
  MoveJoinCommunityCTA = 'specs.profileCardOOI.JoinCommunityCTAUnderMoreActions',
  EnableNewButtonSettings = 'specs.profileCardOOI.NewButtonSettings',
  EnableProfileDetailsEdit = 'specs.profileCardOOI.EnableProfileDetailsEdit',
  MakeProfileCardRemovableInNewMA = 'specs.profileCardOOI.MakeProfileCardRemovableInNewMA',
  UseMiddlewareForMemberGetter = 'specs.profileCardOOI.UseMiddlewareForMemberGetter',
  UseMiddlewareForRolesMapGetter = 'specs.profileCardOOI.UseMiddlewareForRolesMapGetter',
  UseMiddlewareForGlobalSettingsGetter = 'specs.profileCardOOI.UseMiddlewareForGlobalSettingsGetter',
  UseBlockedCheckFollowButton = 'specs.profileCardOOI.UseBlockedCheckFollowButton',
}
